import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownShortIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 3V10M6 10L9.5 6.5M6 10L2.5 6.5",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowDownShortIcon;
